module.exports = __webpack_public_path__ + "img/banner1.9e0a8b8b.png";